import React, { useEffect, useState } from "react";
import axios from "axios";

const COUNTRY_ID_MAP = {
  Canada: 1,
  "United States": 2,
};

const POSTAL_RULES = {
  Canada: {
    pattern: /^[A-Z]\d[A-Z] \d[A-Z]\d$/,
    placeholder: "e.g. A1A 1A1",
    title: "Format: A1A 1A1",
  },
  "United States": {
    pattern: /^\d{5}(-\d{4})?$/,
    placeholder: "e.g. 90210 or 90210-1234",
    title: "Format: 90210 or 90210-1234",
  },
};

function AddressSection({ form, setForm, countries, disabled = false }) {
  const [provinces, setProvinces] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  /* =============================
     Fetch provinces when country changes
     ============================= */
  useEffect(() => {
    const countryId = COUNTRY_ID_MAP[form.country];
    if (!countryId) {
      setProvinces([]);
      return;
    }

    const token = localStorage.getItem("token");

    axios
      .get(`${BASE_URL}/api/dropdowns/provinces/${countryId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const list = Array.isArray(res.data)
          ? res.data
          : res.data?.provinces || [];

        setProvinces(list);
      })
      .catch(() => setProvinces([]));
  }, [form.country, BASE_URL]);

  const postalRule = POSTAL_RULES[form.country] || {};

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]:
        name === "postal_code" && form.country === "Canada"
          ? value.toUpperCase()
          : value,
    }));
  };

  const hasProvinceDropdown = ["Canada", "United States"].includes(
    form.country,
  );

  return (
    <div className="row mb-3">
      {/* Country */}
      <div className="col-md-3">
        <label>
          Country <span className="text-danger">*</span>
        </label>
        <select
          name="country"
          className="form-select"
          value={form.country || ""}
          onChange={handleChange}
          required
          disabled={disabled}
        >
          <option value="">Select</option>
          {countries.map((c) => (
            <option key={c.id} value={c.country_name}>
              {c.country_name}
            </option>
          ))}
        </select>
      </div>

      {/* Province / State */}
      <div className="col-md-3">
        <label>
          Province / State <span className="text-danger">*</span>
        </label>

        {hasProvinceDropdown ? (
          <select
            name="province"
            className="form-select"
            value={form.province || ""}
            onChange={handleChange}
            required
            disabled={disabled}
          >
            <option value="">Select</option>
            {provinces.map((p) => (
              <option key={p.id} value={p.province_name}>
                {p.province_name}
              </option>
            ))}
          </select>
        ) : (
          <input
            type="text"
            name="province"
            className="form-control"
            value={form.province || ""}
            onChange={handleChange}
            required
            disabled={disabled}
          />
        )}
      </div>

      {/* City */}
      <div className="col-md-3">
        <label>
          City <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          name="city"
          className="form-control"
          value={form.city || ""}
          onChange={handleChange}
          required
          disabled={disabled}
        />
      </div>

      {/* Postal / ZIP */}
      <div className="col-md-3">
        <label>
          Postal / ZIP Code <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          name="postal_code"
          className="form-control"
          value={form.postal_code || ""}
          onChange={handleChange}
          placeholder={postalRule.placeholder}
          pattern={postalRule.pattern?.source}
          title={postalRule.title}
          required
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default AddressSection;
